//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { createSelector } from 'reselect';

import { getEcomProvider } from '@insights/redux/selectors/getInsightsEcomConnection';
import { EcommerceProvider } from '@models/MetricsGatewayApiModels';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO PD-297299: Cleanup after GA
export const getIsBvPixelEnabled = createHasFeatureSelector(
  FeatureNames.BvPixel,
);

export const getShouldHideRevenueStatsForBvPixel = createSelector(
  getEcomProvider,
  getIsBvPixelEnabled,
  (ecomProvider, isBvPixelEnabled) =>
    ecomProvider === EcommerceProvider.BvPixel && !isBvPixelEnabled,
);

export const getIsBvPixelConnected = createSelector(
  getEcomProvider,
  getIsBvPixelEnabled,
  (ecomProvider, isBvPixelEnabled) =>
    ecomProvider === EcommerceProvider.BvPixel && isBvPixelEnabled,
);
